"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _inlineLink = require("./inline-link");

var _default = function _default(textColor) {
  return (0, _styledComponents.css)(["ul{list-style:circle;padding:0;padding-left:0.5em;margin-bottom:1.5em;&:last-of-type{margin-bottom:0;}li{margin:0.75em 0 0.75em 1em;position:relative;> a{", ";}}}"], (0, _inlineLink.inlineLinkUnderline)(textColor));
};

exports["default"] = _default;